<script lang="ts">
	import type { RouterOutputs } from "#trpc/router.js";
	import type { Snippet } from "svelte";

	type PublicListing = RouterOutputs["public"]["investmentListings"]["getActiveListings"][number];

	let { listings, children }: { listings: PublicListing[] | null; children: Snippet } = $props();
</script>

{#if listings === null || listings.length === 0}
	<div class="mt-16 items-center justify-center text-center">
		<span class="text-muted-foreground text-xl font-bold">No listings found</span>
	</div>
{:else}
	<div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
		{@render children?.()}
	</div>
{/if}
